import { hasProp } from "./hasProp.js";
import { parsePropPath } from "./parsePropPath.js";




export function tryGet (obj: unknown, path: PropertyKey | PropertyKey[], defaultValue: unknown = undefined)
{
  const pathArray = parsePropPath(path);
  let result: unknown = obj;
  for (const key of pathArray)
  {
    if (result != null && hasProp(result, key))
    {
      result = (result as object)[ key ];
    }
    else
    {
      break;
    }
  }
  return (result === undefined) ? defaultValue : result;
}
